import { Fragment } from "react"
import { useSelector } from "react-redux"
import TicketListing from "./TicketListing"
import AttendeeStepper from "./AttendeeStepper"
import TicketNavigationTabs from "../../../components/event-preview/TicketNavigationTabs"
import Checkout from "./Checkout"

function TicketBuyingFlow({ eventData }) {
    const activeStep = useSelector((state) => state.ticketBuying.activeStep);

    return (
        <Fragment>
            <div className="ticket-add-to-card-container">
                <TicketNavigationTabs />

                <div className="event-ticket-purchase-ui">

                    {activeStep === "tickets" && <TicketListing eventData={eventData} />}
                    {activeStep === "attendee" && <AttendeeStepper />}
                    {activeStep === "payment" && <Checkout />}

                </div>
            </div>
        </Fragment>
    )
}

export default TicketBuyingFlow

/**
 * Trigger points to show the event cancelled modal
 * 1. On "Proceed to Attendee" Form Button
 * 2. On "Next" button of "Fill Attendee Details" step
 * 3. On "Proceed to Payment" button of "Attendee Info" step
 * 4. On "Proceed to Payment" button of "Payment" step
*/

/**1. Event Cancelled
 * 2. Event Drafted & already published once
 * Error Handling Part:
 * 1. On a new ticket buying process clear the localStorage key called "continuedBooking" before starting the process. In this process if backend gives "Event Cancelled" or "Event Drafted" error then show the modal with the respective message. and go to homepage button.
 * 
 * 2. On an existing ticket buying process if in any tab if backend gives the error 
 * 2.1 Event Cancelled -> show the modal with "Event Cancelled" message and go to homepage button.
 * 2.2 Event Drafted && Event Once Published -> show the modal with "Event Drafted" message and and two buttons "Go to Homepage" and "Continue Booking". On "Continue Booking" button click continue the existing booking process by adding the localStorage key called "continuedBooking" with value "true". and attached this key in the request header for all ticket buying related api calls furthers
 */